// components/Generator/CircularProgressCustom.tsx
"use client";
import "./CircularProgressCustom.css";

const CircularProgressCustom = ({ percentage = 0, queuePosition = 0 }) => {
  const radius = 105;
  const strokeWidth = 8;
  const normalizedRadius = radius - strokeWidth * 0.5;
  const circumference = normalizedRadius * 2 * Math.PI;

  const fullCircle = circumference;
  const visibleSlice = 25; // This can be adjusted to change the size of the visible slice

  const strokeDasharray = percentage === 100 ? `${visibleSlice} ${fullCircle}` : `${fullCircle}`;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div style={{ position: "relative", width: `${radius * 2}px`, height: `${radius * 2}px` }}>
      <svg
        height={radius * 2}
        width={radius * 2}
        style={{
          transform: "rotate(-90deg)",
          animation: `${percentage === 100 ? "spin 2s linear infinite" : "none"}`,
        }}
      >
        <circle
          stroke="#374151"
          fill="transparent"
          strokeWidth={strokeWidth}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          stroke="url(#gradient)"
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={strokeDasharray}
          strokeDashoffset={strokeDashoffset}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <defs>
          <linearGradient id="gradient" x1="30%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FF0D65" />
            <stop offset="100%" stopColor="#0040C1" />
          </linearGradient>
        </defs>
      </svg>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "20px",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        {percentage === 100 ? "Loading..." : `${percentage.toFixed(0)}%`}
      </div>
      {queuePosition > 0 && (
        <div
          style={{
            position: "absolute",
            top: "60%",
            left: "75%",
            transform: "translate(-50%, -50%)",
            fontSize: "14px",
            color: "#374151",
            width: "100%",
          }}
        >
          {`Queue order: ${queuePosition}`}
        </div>
      )}
     
    </div>
  );
};

export default CircularProgressCustom;
